<template>
  <div id="vueAlert" :class="className">
    <transition-group name="fade" tag="div">
      <div class="confirm" @click.stop="closeAlert" key="1" v-show="show"></div>
    </transition-group>
    <transition-group name="fade" tag="div">
      <div class="confirm-dialog alert-dialog" key="2" v-show="show" :style="{ top }">
        <div class="flex-1 c-container">
          <p class="c-title" v-if="title" v-html="title"></p>
          <p class="gap" v-if="!title"></p>
          <div class="c-con" v-if="text">{{ text }}</div>
          <div class="c-con c-state" v-if="state">{{ state }}</div>
          <div v-if="html" class="c-html" v-html="html"></div>
        </div>
        <div class="btn-confirm flex">
          <span class="flex-1" @click.stop="sureFunc()">{{ sureText }}</span>
        </div>
      </div>
    </transition-group>
  </div>
</template>
<script>
import eventBus from '../event-bus';
let timer;
let timer2;
export default {
  data() {
    return {
      className: '',
      show: false,
      title: '',
      enabledBgClose: false,
      top: '50%',
      text: '',
      state: '', // 一句声明文案
      html: '',
      titleColor: '#333',
      textColor: '#999',
      sureText: '确定',
      sureColor: '#F9940E',
      disableAutoClose: false,
      cancel: null,
      callback: null,
    };
  },
  mounted() {
    eventBus.$on('dialog-alert', this.showItem);
  },
  methods: {
    showItem(options) {
      const setData = key => {
        if (typeof options[key] !== 'undefined') {
          this[key] = options[key];
        }
      };
      const keys = [
        'className',
        'show',
        'title',
        'enabledBgClose',
        'top',
        'text',
        'state',
        'html',
        'titleColor',
        'textColor',
        'sureText',
        'sureColor',
        'disableAutoClose',
        'cancel',
        'callback',
      ];
      keys.forEach(v => setData(v));
      if (typeof options.show !== 'boolean') {
        this.show = true;
      }
    },
    closeAlert() {
      this.cancel && this.cancel();
      if (!this.enabledBgClose) {
        return;
      }
      this.show = false;
    },
    sureFunc() {
      console.log('this.callback', this.callback);
      this.callback && this.callback();
      if (!this.disableAutoClose) {
        this.show = false;
      }
    },
    clearData() {
      //清除上一次进入时所保留的值
      timer2 = setTimeout(() => {
        this.title = '';
        this.text = '';
        this.state = '';

        this.html = '';
        this.titleColor = '#F9940E';
        this.textColor = '#999';

        this.sureText = '确定';
        this.sureColor = '#F9940E';

        this.callback = null;
      }, 100);
    },
  },
  watch: {
    show() {
      if (!this.show) {
        timer = setTimeout(() => {
          console.log({ timer });
          this.clearData();
        }, 300);
      } else {
        console.log({ timer, timer2 });
        timer && clearTimeout(timer);
        timer2 && clearTimeout(timer2);
      }
    },
  },
};
</script>
<style scoped lang="scss">
@use '@/assets/css/_themeify.scss' as *;

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-active,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to {
  opacity: 1;
}

.confirm {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1008;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
}

.confirm-dialog {
  background-color: #fff;

  @include all_themeify {
    background: themed(dialog-bg);
  }

  @include lexis_themeify {
    background: themed(ui_card_primary_background);
  }

  position: fixed;
  display: table;
  z-index: 5000;
  width: calc(100% - 80px);
  max-width: 300px;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
  border-radius: 16px;
  overflow: hidden;
}

.c-container {
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.c-container .c-title {
  color: rgba(0, 0, 0, 0.87);

  @include all_themeify {
    color: themed(text_primary);
  }

  @include lexis_themeify {
    color: themed(text_primary);
  }

  font-weight: 500;
  font-size: 18px;
  padding: 24px 8px 8px;
  line-height: 24px;
  word-break: break-all;
  white-space: normal;
}

.c-container .gap {
  height: 32px;
}

.c-container .c-con {
  color: var(--IC-text-secondary-l, rgba(0, 0, 0, 0.54));
  // color: rgba(0, 0, 0, 0.87);
  margin: 0 15px;

  @include all_themeify {
    color: themed(text_primary);
  }

  @include lexis_themeify {
    color: themed(text_primary);
  }

  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}

.c-container .c-state {
  color: rgba(0, 0, 0, 0.87);
  margin: 20px 15px 0;

  @include all_themeify {
    color: themed(text_primary);
  }

  @include lexis_themeify {
    color: themed(text_primary);
  }

  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  white-space: pre-line;
}

.btn-confirm {
  text-align: center;
  width: 100%;
  justify-content: space-around;
  padding: 32px 24px 24px;
}

.btn-confirm span:last-child {
  border-left: 1px solid #eee;
}

.btn-confirm span {
  display: block;
  line-height: 40px;
  height: 40px;
  border-radius: 20px;
  font-weight: 500;
  font-size: 16px;
  background: #ff6800;
  color: rgba(255, 255, 255, 0.87);

  @include all_themeify {
    background: themed(secondary_highlight);
    color: themed(highlight);
  }

  @include lexis_themeify {
    background: themed(ui_brand_primary);
    color: themed('text_inverse_primary');
  }
}
</style>
